import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import LogOutButton from '../LogOutButton/LogOutButton';
import Seo from '../Seo/Seo';

// this could also be written with destructuring parameters as:
// const UserPage = ({ user }) => (
// and then instead of `props.user.username` you could use `user.username`
const UserPage = (props) => (
  <div style={{ marginTop: 70, padding: 30 }}>
    <Seo
      title="Trivia Weekend | Team Hub"
      description="Access your Trivia Weekend team hub to jump into live rounds, visual trivia, scheduling, and settings."
      canonicalPath="/#/main"
      ogType="website"
    />
    <h1>Welcome to Trivia Weekend</h1>
    <p>Use the navigation bar to move through your trivia command center.</p>
    <p>
      Quick links:{' '}
      <Link to="/home">Team Dashboard</Link>,{' '}
      <Link to="/visual">Visual Trivia</Link>,{' '}
      <Link to="/live">Live Round</Link>,{' '}
      <Link to="/schedule">Schedule</Link>,{' '}
      <Link to="/profile">Team Settings</Link>
    </p>
    <p><b>Or, disappoint your teammates and log out!</b></p>
    <LogOutButton className="log-in" />
  </div>
);

// Instead of taking everything from state, we just want the user info.
// if you wanted you could write this code like this:
// const mapStateToProps = ({user}) => ({ user });
const mapStateToProps = state => ({
  user: state.user,
});

// this allows us to use <App /> in index.js
export default connect(mapStateToProps)(UserPage);
